import React, { useEffect, useState } from 'react';
import './circleRange.scss'
// import './circleRange.css'

const CircleRangeSlider = ({ min, max, onChange, valueSecurity,colorBg }) => {
    const [value, setValue] = useState(min);
    const radius = 150; // Радіус круга в ширину 300px
    const strokeWidth = 20; // Ширина лінії
    // const [colorBg, setColorBg] = useState('#FF0F3C')

    // Перетворення відсотка на кут
    const percentageToDegrees = (percentage) => {

        return percentage * 360;
    };

    useEffect(() => {
        let currentValue = min;
        const increment = (valueSecurity - currentValue) / 100;

        const animate = () => {
            currentValue += increment;
            if (currentValue < valueSecurity) {
                setValue(currentValue);
                setTimeout(animate, 10);
            } else {
                setValue(valueSecurity);
            }
        };

        animate();
    }, [valueSecurity, min]);

    // useEffect(() => {
    //     if (valueSecurity >= 100) {
    //         setColorBg('#D8BE8D');
    //     } else if (valueSecurity >= 90) {
    //         setColorBg('#58B90A');
    //     } else if (valueSecurity >= 35) {
    //         setColorBg('#EF9D00');
    //     } else {
    //         setColorBg('#FF0F3C');
    //     }
    // }, [valueSecurity]); 

    // Обробник зміни слайдера
    const handleChange = (event) => {
        const newValue = event.target.value;
        setValue(newValue);
        onChange(newValue);
    };

    const circumference = 2 * Math.PI * (radius - strokeWidth / 2);
    const strokeLength = ((value - min) / (max - min)) * circumference;


    return (
        <div className="circle-range-slider">
            <div className="circle-range-slider-title">
            <h1 style={{color:colorBg}}>Security</h1>
            <p>Score <span style={{color:colorBg}}>{valueSecurity} </span></p>
            </div>
            <svg width={'100%'} height={'100%'}>
                <circle
                    className='circle-range-slider_bg_sircule'
                    cx={radius}
                    cy={radius}
                    r={radius - strokeWidth / 2}
                    stroke={colorBg}
                    strokeWidth={strokeWidth}
                    fill="none"
                />
                <circle
                    cx={radius}
                    cy={radius}
                    r={radius - strokeWidth / 2}
                    stroke={colorBg}
                    strokeWidth={strokeWidth}
                    fill="none"
                    // strokeDasharray={`${percentageToDegrees((value - min) / (max - min))}, ${2 * Math.PI * (radius - strokeWidth / 2)}`}
                    strokeDasharray={`${strokeLength} ${circumference}`}
                    strokeLinecap="round"
                    transform={`rotate(-90 ${radius} ${radius})`}
                />
            </svg> 
             <input
                type="range"
                min={min}
                max={max}
                value={value}
                onChange={handleChange}
                disabled
                className="circle-range-input"
            />

        </div>
    );
};

export default CircleRangeSlider;